import { useSearchParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
// Image - use regular img tag

/**
 * The classic confirm password page.
 */
function ClassicConfirmPasswordPage() {
	const [searchParams] = useSearchParams();
	// URLSearchParams treats "+" as space for query values. Normalize back for email aliases.
	const email = searchParams.get('email')?.replace(/ /g, '+');
	const navigate = useNavigate();

	return (
		<div className="flex min-w-0 flex-auto flex-col items-center sm:justify-center">
			<Paper className="bg-white min-h-full w-full rounded-none px-4 py-8 sm:min-h-auto sm:w-auto sm:rounded-xl sm:p-12 sm:shadow-sm">
				<div className="mx-auto w-full max-w-80 sm:mx-0 sm:w-80 flex flex-col items-center">
					<img
						src="/assets/images/logo/logo_loanapp.png"
						alt="ASSETS ID"
						width={165}
						height={70}
					/>

					<div className="w-full">
						<Typography className="mt-8 text-4xl font-extrabold leading-[1.25] tracking-tight">
							Check Your Email
						</Typography>
						<div className="mt-0.5 flex items-baseline font-medium">
							<Typography>
								We've just sent instructions to reset your password to <strong>{email || ''}</strong>.
								Follow the next steps in that email.
							</Typography>
						</div>

						<div className="mt-8 flex w-full flex-col justify-center">
							<Button
								variant="contained"
								color="secondary"
								className=" mt-1 w-full"
								aria-label="Register"
								type="submit"
								size="large"
								startIcon={<ReplayIcon />}
								onClick={() => navigate('/forgot-password')}
							>
								Send reset link again
							</Button>

							<Typography
								className="mt-8 text-md font-medium"
								color="text.secondary"
							>
								<span>
									Remember to check your spam folder or unblock no-reply@assetsid.com if you can't
									find the message.
								</span>
							</Typography>
						</div>
					</div>
				</div>
			</Paper>
		</div>
	);
}

export default ClassicConfirmPasswordPage;
